const LOOPBACK_HOSTNAMES = ["localhost", "127.0.0.1", "[::1]"];

function parseUri(uri: string): URL | null {
  try {
    return new URL(uri);
  } catch {
    return null;
  }
}

export function isLoopbackHttpUri(uri: string): boolean {
  const url = parseUri(uri);
  return (
    url !== null &&
    url.protocol === "http:" &&
    LOOPBACK_HOSTNAMES.includes(url.hostname)
  );
}

// Private-use URI schemes for the native app clients we support (RFC 8252).
// Allowlist, not blocklist: add a scheme here to onboard a new native client.
// Mandatory PKCE guards against local scheme-hijack code interception.
const ALLOWED_NATIVE_SCHEMES = ["cursor:", "vscode:", "vscode-insiders:"];

export function isAllowedRedirectUri(uri: string): boolean {
  const url = parseUri(uri);
  if (!url || url.hash) return false;
  if (url.protocol === "https:") return true;
  if (isLoopbackHttpUri(uri)) return true;
  return ALLOWED_NATIVE_SCHEMES.includes(url.protocol);
}

// RFC 8252 §7.3: loopback clients bind an ephemeral port at runtime, so the
// port is the one component that may differ from the registered URI.
export function redirectUriMatches(
  registered: string,
  presented: string,
): boolean {
  if (registered === presented) return true;
  if (!isLoopbackHttpUri(registered) || !isLoopbackHttpUri(presented)) {
    return false;
  }
  const a = new URL(registered);
  const b = new URL(presented);
  return (
    a.hostname === b.hostname &&
    a.pathname === b.pathname &&
    a.search === b.search
  );
}
